import React, { useState } from "react";
import { Crown, Plus, X } from "lucide-react";

import Avatar from "./Avatar";
import ConviteMesa from "./ConviteMesa";

const VISIVEIS = 4;

// Quem está na mesa, no canto superior direito da comanda: os rostos
// empilhados e, ao tocar, a lista com nomes (o anfitrião com a coroa). Para o
// anfitrião, quem ainda espera liberação aparece na lista com Liberar/Recusar,
// e embaixo vem o link de convite (o "+" nos rostos é o atalho pra ele).
export default function ParticipantesMesa({ dados, euId, fotoDe, darkMode, onDecidir, linkConvite, mesa }) {
  const [aberta, setAberta] = useState(false);
  const lista = dados?.participantes || [];
  const pendentes = dados?.pendentes || [];
  if (!lista.length && !pendentes.length) return null;

  const extras = lista.length - VISIVEIS;
  const folha = darkMode ? "bg-zinc-900 text-zinc-100" : "bg-white text-zinc-900";

  return (
    <>
      <button
        type="button"
        onClick={() => setAberta(true)}
        data-e2e="mesa-participantes"
        className="relative flex items-center"
        aria-label={`${lista.length} ${lista.length === 1 ? "pessoa" : "pessoas"} na mesa`}
      >
        {/* Fundo branco por baixo: a inicial do Avatar é translúcida e, sem
            ele, o rosto de trás apareceria através do da frente. */}
        {lista.slice(0, VISIVEIS).map((p, i) => (
          <span key={p.cliente_id} className={`rounded-full bg-white ring-2 ring-primary ${i ? "-ml-1.5" : ""}`}>
            <Avatar nome={p.nome} foto={p.foto} fotoDe={fotoDe} tamanho={34} />
          </span>
        ))}
        {extras > 0 ? (
          <span className="-ml-1.5 w-[34px] h-[34px] rounded-full ring-2 ring-primary bg-white text-primary text-xs font-black flex items-center justify-center">
            +{extras}
          </span>
        ) : null}
        {linkConvite ? (
          <span className="ml-1.5 w-[34px] h-[34px] rounded-full border-2 border-dashed border-white/80 text-white flex items-center justify-center"
                data-e2e="mesa-convidar" aria-hidden>
            <Plus className="w-4 h-4" />
          </span>
        ) : null}
        {pendentes.length ? (
          <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-amber-400 text-zinc-900 text-[10px] font-black flex items-center justify-center">
            {pendentes.length}
          </span>
        ) : null}
      </button>

      {aberta ? (
        <div className="fixed inset-0 z-[80] bg-black/50 flex items-end" onClick={() => setAberta(false)}>
          <div
            className={`w-full rounded-t-3xl px-5 pt-5 pb-8 max-h-[75vh] overflow-y-auto ${folha}`}
            onClick={(e) => e.stopPropagation()}
            data-e2e="mesa-participantes-lista"
          >
            <div className="flex items-center mb-4">
              <h3 className="text-lg font-black">Na mesa</h3>
              <button type="button" onClick={() => setAberta(false)} className="ml-auto p-2 -mr-2 opacity-60" aria-label="Fechar">
                <X className="w-5 h-5" />
              </button>
            </div>
            <ul className="space-y-3">
              {lista.map((p) => (
                <li key={p.cliente_id} className="flex items-center gap-3">
                  <Avatar nome={p.nome} foto={p.foto} fotoDe={fotoDe} tamanho={40} />
                  <span className="font-bold flex-1 min-w-0 truncate">
                    {p.cliente_id === euId ? `${p.nome} (você)` : p.nome}
                  </span>
                  {p.papel === "anfitriao" ? (
                    <span className="flex items-center gap-1 text-xs font-bold text-amber-500">
                      <Crown className="w-4 h-4" /> abriu a mesa
                    </span>
                  ) : null}
                </li>
              ))}
            </ul>
            {pendentes.length ? (
              <>
                <p className="mt-6 mb-3 text-xs font-bold uppercase tracking-widest opacity-60">Querem entrar</p>
                <ul className="space-y-3">
                  {pendentes.map((p) => (
                    <li key={p.cliente_id} className="flex items-center gap-3">
                      <Avatar nome={p.nome} foto={p.foto} fotoDe={fotoDe} tamanho={40} />
                      <span className="font-bold flex-1 min-w-0 truncate">{p.nome}</span>
                      <button type="button" onClick={() => onDecidir(p.cliente_id, false)}
                        className="h-9 px-3 rounded-full border text-xs font-bold opacity-80">Recusar</button>
                      <button type="button" onClick={() => onDecidir(p.cliente_id, true)}
                        className="h-9 px-4 rounded-full bg-primary text-primary-foreground text-xs font-black">Liberar</button>
                    </li>
                  ))}
                </ul>
              </>
            ) : null}
            <ConviteMesa link={linkConvite} mesa={mesa} anfitriao={dados?.anfitriao} />
          </div>
        </div>
      ) : null}
    </>
  );
}
